import { Formik } from "formik";
import { YUPValidations } from "./helper";
import { useEffect, useState } from "react";
import {
  MandatoryStar,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../../../Utils/helper";
import { useDispatch, useSelector } from "react-redux";
import {
  addProviderSKUTestAction,
  getSKUTestDetailByIdAction,
  getSkuTestPackagesAction,
} from "../../../../redux/actions/TestPackagesAction";
import { clearCurrentPage } from "../../../NetworkPortal/ProviderProfileDetails/helper";
import { useLocation } from "react-router-dom";

export const AddQuicklyTestSKUPopup = ({
  userDetail,
  providerSKUTestMapStgId,
  providerPermanentTestMapStgId,
  setIsAddSku,
  setProviderSKUTestMapStgId,
  setProviderPermanentTestMapStgId,
  searchFilter,
  apiParams,
  facilityId,
  setFacilityId,
}) => {
  const location = useLocation()
  let source = location?.search.split("=")[1]
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const TestPackageReducer = useSelector((state) => state?.TestPackageReducer);
  useEffect(() => {
    if (providerSKUTestMapStgId !== null) {
      const resp = dispatch(
        getSKUTestDetailByIdAction(
          providerSKUTestMapStgId,
          providerPermanentTestMapStgId
        )
      );
      resp.then((res) => {
        setData(res?.data?.results);
      });
    }
  }, [providerSKUTestMapStgId]);

  const handleClose = async () => {
    setIsAddSku(false);
    setProviderSKUTestMapStgId(null);
    setProviderPermanentTestMapStgId(null);
    setData(null);
    setFacilityId(null);
    await dispatch(getSkuTestPackagesAction({ ...searchFilter, ...apiParams }));
  };

  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black">
          {providerSKUTestMapStgId === null ? "Add SKU" : "Edit SKU"}
        </h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={handleClose}
        ></button>
      </div>
      <Formik
        enableReinitialize={true}
        initialValues={{ ...data }}
        onSubmit={async (values) => {
          const temp = {
            ...values,
            mrp: values?.mrp,
            walkInPrice: values?.walkInPrice,
            ProviderSKUTestStgId:
              providerSKUTestMapStgId === null ? 0 : values?.providerSKUTestId,
            providerSKUTestId: providerPermanentTestMapStgId,
            FacilityId: facilityId,
            hvChargesId: values?.hvChargesId === "" ? 0 : values?.hvChargesId,
          };
          const resp = dispatch(addProviderSKUTestAction(source === "WhatsApp" || source === "Email"? {...temp,source:source}: temp));
          resp.then((res) => {
            isLoadingAction(true, dispatch);
            if (res?.data?.status === true) {
              clearCurrentPage(dispatch);
              getSnackbarSuccess("success", res?.data?.message, dispatch);
              isLoadingAction(false, dispatch);
              handleClose();
            } else {
              getSnackbarSuccess("error", res?.data?.message, dispatch);
              isLoadingAction(false, dispatch);
            }
          });
        }}
        validationSchema={YUPValidations}
      >
        {(props) => {
          const { values, errors, handleChange, handleSubmit, setFieldValue } =
            props;
          return (
            <form className="form-admin" onSubmit={handleSubmit}>
              <div className="modal-body addusermodalbox">
                {providerSKUTestMapStgId !== null && (
                  <p>
                    <label className="col-form-label">HA SKU Name:&nbsp;</label>
                    <label className="col-form-label">
                      {userDetail?.haskuName}
                    </label>
                  </p>
                )}
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor=" Role" className="col-form-label">
                      Centre SKU Code
                      <MandatoryStar />
                    </label>
                    <input
                      name="centreSKUCode"
                      type="text"
                      placeholder="Centre SKU Code"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.centreSKUCode}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">
                      {errors?.centreSKUCode}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="User Type" className="col-form-label">
                      Centre SKU Name
                      <MandatoryStar />
                    </label>
                    <input
                      name="centreSKUName"
                      type="text"
                      placeholder="Centre SKU Name"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.centreSKUName}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">
                      {errors?.centreSKUName}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor=" Role" className="col-form-label">
                      HV Charges For
                      <span style={{ fontSize: "12px" }}> (if applicable)</span>
                    </label>
                    <select
                      name="hvChargesId"
                      className="form-select form-select-admin"
                      value={values?.hvChargesId}
                      onChange={handleChange}
                    >
                      <option value="">Select HV Charges For</option>
                      {TestPackageReducer?.getHVChargesForDetails?.map(
                        (ele, index) => {
                          return (
                            <option key={index} value={ele?.hvChargesId}>
                              {ele?.displayName}
                            </option>
                          );
                        }
                      )}
                    </select>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor=" Role" className="col-form-label">
                      Test Type
                      <MandatoryStar />
                    </label>
                    <select
                      name="testTypeId"
                      className="form-select form-select-admin"
                      value={values?.testTypeId}
                      onChange={handleChange}
                    >
                      <option value="">Select Test Type</option>
                      {TestPackageReducer?.getTestTypeDetails?.map(
                        (ele, index) => {
                          return (
                            <option key={index} value={ele?.testTypeId}>
                              {ele?.displayName}
                            </option>
                          );
                        }
                      )}
                    </select>
                    <div className="errorInputMessage">
                      {errors?.testTypeId}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label htmlFor="Email" className="col-form-label">
                      MRP
                      <MandatoryStar />
                    </label>
                    <input
                      name="mrp"
                      type="number"
                      step="0.01"
                      presicion={2}
                      onKeyDown={(e) => {
                        if (e.key === " " || e.key === "-" || e.key === "+") {
                          e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                        }
                      }}
                      placeholder="MRP"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.mrp}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">{errors?.mrp}</div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label htmlFor=" Role" className="col-form-label">
                      Walk-in Price
                      <MandatoryStar />
                    </label>
                    <input
                      name="walkInPrice"
                      type="number"
                      step="0.01"
                      presicion={2}
                      onKeyDown={(e) => {
                        if (e.key === " " || e.key === "-" || e.key === "+") {
                          e.preventDefault(); // Prevent entering a space, minus sign, or plus sign
                        }
                      }}
                      placeholder="Walk-in Price"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.walkInPrice}
                      onChange={handleChange}
                    />
                    <div className="errorInputMessage">
                      {errors?.walkInPrice}
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label htmlFor=" Role" className="col-form-label">
                      Is Outsourced
                      <MandatoryStar />
                    </label>
                    <select
                      name="isOutSourced"
                      className="form-select form-select-admin"
                      value={values?.isOutSourced}
                      onChange={(e) => {
                        setFieldValue(
                          "isOutSourced",
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                            ? false
                            : e.target.value
                        );
                      }}
                    >
                      <option value="">Select</option>
                      <option value={true}>Yes</option>
                      <option value={false}>No</option>
                    </select>
                    <div className="errorInputMessage">
                      {errors?.isOutSourced}
                    </div>
                  </div>
                  {(userDetail?.requestStatus === "Rejected" ||
                    userDetail?.requestStatus === "Accepted") &&
                    data?.remarks && (
                      <div className="remarks mt-4">
                        <h5 className="font-bold text-black bottom-spacing-20 mb-3">
                          Remarks
                        </h5>
                        <textarea
                          className="textarea textareaConfirmation font-medium"
                          style={{ height: "130px" }}
                          placeholder="Type Something Here..."
                          value={data?.remarks}
                          disabled={true}
                        ></textarea>
                      </div>
                    )}
                </div>
              </div>
              <div className="modal-footer modal-footer-admin accept-reject-btns bottom-0  mt-4">
                <button type="submit" className="savedetails">
                  <img
                    style={{ marginRight: "6px" }}
                    src={
                      window.location.pathname.includes("campaigns")
                        ? "../../images/save-icon-white.png"
                        : "./images/save-icon-white.png"
                    }
                  />
                  Save
                </button>
              </div>
            </form>
          );
        }}
      </Formik>
    </>
  );
};
